import { FC, SVGProps } from 'react';

const EnterpriseAnalyticsIcon: FC<SVGProps<SVGSVGElement> & { size?: number }> = ({
  color = '#fff',
  size = 20,
  ...props
}) => {
  return (
    <svg width={size} height={size} viewBox="0 0 20 20" xmlns="http://www.w3.org/2000/svg" {...props} fill="none">
      <path
        d="M6.11182 9.07637V14.2218M9.61158 6.61462V14.2216M13.0544 11.7955V14.2214"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.765 2.91663H6.06944C3.61998 2.91663 2.0835 4.65095 2.0835 7.10608V13.728C2.0835 16.1831 3.61269 17.9166 6.06944 17.9166H13.0976C15.5551 17.9166 17.0835 16.1831 17.0835 13.728V11.2728"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.9165 4.58337L15.4165 2.08337M15.4165 2.08337L17.9165 4.58337M15.4165 2.08337V7.91671"
        stroke={color}
        stroke-width="1.5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};

export default EnterpriseAnalyticsIcon;
